<template>
  <div>
    <div class="mt-4 px-2">
      <template v-if="step === 2">
        <div class="d-flex align-center">
          <v-btn
            text
            icon
            color="cyan"
            @click="back"
            :disabled="this.params.action === 'getReport'"
          >
            <v-icon v-if="this.params.action === 'getReport'">mdi-paw</v-icon>
            <v-icon v-else>mdi-arrow-left</v-icon>
          </v-btn>
          <span>請選擇畜主{{ user.name }}的寵物</span>
        </div>
      </template>
      <template v-else-if="step === 3">
        <div class="d-flex align-center">
          <v-btn text icon color="cyan" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span>請選擇『{{ petName }}』的健檢報告</span>
        </div>
      </template>
      <template v-else-if="step === 4">
        <div class="d-flex align-center">
          <v-btn text icon color="cyan" @click="back">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span>新增健檢報告</span>
        </div>
      </template>
    </div>
    <div v-if="step === 1" class="pa-2">
      <breeder-search :clinic="clinic" @search="search"></breeder-search>
      <qr-code-hint class="mt-4" hint="或是你可使用Line內建#掃一掃NxVet網頁中，寵物健檢報告的專屬條碼"></qr-code-hint>
    </div>
    <div v-if="step === 2" class="px-2">
      <type-tab class="mt-4" v-model="tab"></type-tab>
      <card-pet
        :phone="phone"
        style="margin-left:-4px;margin-right:-4px"
        class="mt-4"
        ref="cardPet"
        :clinic="clinic"
        @onSelect="selectPet"
        :filter="tab"
      ></card-pet>
    </div>
    <list-report
      class="mt-4"
      :userName="user.name"
      :userPhone="phone"
      :doctor="doctor.name"
      :createBtn="params.action === 'setReport'"
      :clinic="clinic"
      :petId="petIdNow"
      v-else-if="step === 3"
      ref="listReport"
      @onSelect="selectReport"
      @onCreate="() => (step = 4)"
    ></list-report>
    <new-report
      class="mt-4"
      v-else-if="step === 4"
      :clinic="clinic"
      :userName="user.name"
      :userPhone="phone"
      :petId="petIdNow"
      :pet="petNow"
      @onSelect="selectReport"
    ></new-report>
  </div>
</template>

<script>
import BreederSearch from "./component/BreederSearch";
import QrCodeHint from "./component/QrCodeHint";

import CardPet from "../common/CardPet";
import ListReport from "./component/ListReport";
import NewReport from "./component/NewReport";
import TypeTab from "./component/TypeTab";

export default {
  props: ["clinic"],
  components: {
    BreederSearch,
    CardPet,
    ListReport,
    NewReport,
    TypeTab,
    QrCodeHint
  },
  data: () => ({
    profile: {},
    phone: "",
    params: {},
    user: {},
    step: 1,
    pets: [],
    petName: "",
    doctor: {},
    petIdNow: "",
    petNow: "",
    petNum: 0,
    tab: "all"
  }),
  methods: {
    async selectPet(petId, pet) {
      // console.log("onSelect petId:" + petId);
      this.petIdNow = petId;
      this.petNow = pet;
      this.petName = pet.name;
      this.step = 3;
    },
    async selectReport(reportId) {
      // console.log("onSelect reportId:" + reportId);
      try {
        await this.$ajax.post(
          `${this.$config.apiUrl}/${this.clinic}/liff/bot/${this.profile.userId}`,
          {
            action: this.params.action,
            selectId: reportId
          }
        );
      } catch (e) {
        alert("send action error:" + e);
      }

      if (this.$liff.isInClient()) {
        this.$liff.closeWindow();
      } else {
        window.location.href = `line://oaMessage/${this.params.botId}/`;
      }
    },
    async getUser() {
      if (!this.phone) {
        return;
      }
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.clinic}/search/user`,
        { phone: this.phone }
      );
      this.user = response.data[0];
    },
    async back() {
      if (this.step === 3 && this.petNum === 1) {
        //only one pet ignore pet card select
        this.step = 1;
      } else {
        this.step--;
      }
      console.log("tab:" + this.tab);
      await this.$nextTick();
    },
    async getProfile() {
      if (process.env.NODE_ENV === "development") {
        this.profile.userId = "Udef0da4cc49048f0ae7adf34dad40ec6";
      } else {
        this.profile = await this.$liff.getProfile();
        //this.profile.userId = "Udef0da4cc49048f0ae7adf34dad40ec6";
      }
    },
    async getDoctor() {
      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/users/bot/${this.profile.userId}`
      );
      this.doctor = response.data;
    },
    async search(phone) {
      this.phone = phone;
      await this.getUser();

      let response = await this.$ajax.get(
        `${this.$config.apiUrl}/${this.clinic}/pets/${this.phone}/0`
      );
      this.petNum = response.data.length;
      if (this.petNum === 1) {
        //customer only has one pet
        this.selectPet(response.data[0]._id, response.data[0]);
      } else {
        this.tab = "all";
        this.step = 2;
      }
    }
  },
  async mounted() {
    if (this.params.action !== "setReport") {
      this.step = 2;
    }

    //liff init
    await this.$liff.init({ liffId: this.params.liffId });
    if (process.env.NODE_ENV === "development") {
      await this.getProfile();
    } else if (this.$liff.isInClient() || this.$liff.isLoggedIn()) {
      //in line app or user already login
      await this.getProfile();
    } else {
      //in external web and not login
      this.$liff.login();
    }

    await this.getDoctor();
    if (this.params.action !== "setReport") {
      this.user = this.doctor;
      this.phone = this.user.phone;
    }
  },
  created() {
    ///liff/selectPetReport/ladyicats?liffId=1491223853-wkP6G72P&botId=@gnx4787y&action=setReport

    //parse url parameter
    const url = new URL(window.location.href);
    let thisVm = this;
    for (let [key, value] of url.searchParams.entries()) {
      thisVm.params[key] = value;
    }
    // alert("params:" + JSON.stringify(thisVm.params));

    if (!this.params.liffId) {
      alert("liffId undefined");
    }

    if (!this.params.botId) {
      alert("botId undefined");
    }
  }
};
</script>
